export const getTomorrowsFullDate = (currentUTCDate) => {
  const tomorrowsFullDate = new Date(
    currentUTCDate.getTime() + 24 * 60 * 60 * 1000,
  );
  return tomorrowsFullDate;
};

export const extractISOString = (fullDate) => {
  return fullDate.toISOString();
};

export const convertToLocalTimezone = (fullDate) => {
  const dateInLocalTimezone = new Date(
    fullDate.getUTCFullYear(),
    fullDate.getUTCMonth(),
    fullDate.getUTCDate(),
  );
  return dateInLocalTimezone;
};
